import { addDays, addYears, getISODay } from "date-fns";
import { DropdownOption, Permit, Vehicle, PermitFormValues, SailingValues } from "../../models/permit";
import { isMobileOnly } from 'react-device-detect';
import { BUTTON_SIZE, BUTTON_SIZE_MOBILE } from "../data/constants";

export const weekDays: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const IsActiveTab = (currentTab: number, tab: number) => {
    return !!(currentTab === tab)
};

export const IsDisableTab = (currentTab: number, tab: number) => { // current tab vs active component, 
    return !!(currentTab < tab)
};

export const IsCompleteTab = (currentTab: number, tab: number) => { // current tab vs active component, 
    return !!(currentTab > tab)
};

export const yearFormatter = (value: string) => {
    const onlyNums = value.replace(/[^\d]/g, "");
    if (!value) return value;
    if (onlyNums.length <= 3) return onlyNums;
    return `${onlyNums.slice(0, 4)}`;
};

export const zipCodeFormatter = (value: string) => {
    const onlyNums = value.replace(/[^\d]/g, "");
    if (!value) return value;
    if (onlyNums.length <= 4) return onlyNums;
    return `${onlyNums.slice(0, 5)}`;
};

export const phoneFormatter = (value: string) => {
    const onlyNums = value.replace(/[^\d]/g, "");
    if (!value) return value;
    if (onlyNums.length <= 3) return onlyNums;
    if (onlyNums.length <= 7) return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 7)}`;

    return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
};

export const normalizePhone = (value: string) => {
    if (!value) return value;
    let onlyNums = value.replace(/[^\d]/g, "");

    // remove 1 if first digit starts with 1
    // if (+onlyNums[0] === 1) {
    //     onlyNums = onlyNums.slice(0, 0);
    // }

    if (onlyNums.length <= 3) return onlyNums;
    if (onlyNums.length <= 6)
        return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 7)}`;
    return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10 )}`;
};

export const normalizeZipCode = (value: string) => {
    if (!value) return value;

    let onlyNums = value.replace(/[^\d]/g, "");
    
    return onlyNums === '' ? '' : parseInt(onlyNums.slice(0, 5));
};

export const normalizeYear = (value: string) => {
    if (!value) return value;

    let onlyNums = value.replace(/[^\d]/g, "");
    
    return onlyNums === '' ? '' : onlyNums.slice(0, 4);
};

export const returnPhoneOrEmpty = (value: string) => {
    // if (xxx) xxx-xxxx format, then just return the value
    // check whether value contains ( at index 0, ) at index 4, and - at index 9 w/ length === 14
    if (value.length === 14 
        && value.charAt(0) === '('
        && value.charAt(4) === ')'
        && value.charAt(9) === '-'
    ) {
        return value;
    }

    return '';
};

export const getClosestDayOfLastWeek = (dayOfWeek: string, fromDate = new Date()) => {
    // follow the getISODay format (7 for Sunday, 1 for Monday)
    const dayOfWeekMap: any = {
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thur: 4,
        Fri: 5,
        Sat: 6,
        Sun: 7,
    };

    // -7 means last week
    // dayOfWeekMap[dayOfWeek] get the ISODay for the desired dayOfWeek

    // e.g. If today is Sunday, getISODay(fromDate) will returns 7
    // if the day we want to find is Thursday(4), apart from subtracting one week(-7),
    // we also need to account for the days between Sunday(7) and Thursday(4)
    // Hence we need to also subtract (getISODay(fromDate) - dayOfWeekMap[dayOfWeek])
    const offsetDays = -7 - (getISODay(fromDate) - dayOfWeekMap[dayOfWeek]);

    return addDays(fromDate, offsetDays);

    // const startOfBootWeek = startOfWeek(new Date(), { weekStartsOn: 1 });
};

export const getMondayOfNextWeek = (today = new Date()) => {
    // 7 means next week

    // e.g. If today is Sunday, getISODay(today) will returns 7
    const offsetDays = 7 - (getISODay(today) - 1);

    return addDays(today, offsetDays);
};

export const getEffectiveThru = (today = new Date()) => { // 365 days + extra 3 days
    return addYears(addDays(today, 3), 1);
};

export const setVehicleOrderSeq = (vehicles: Vehicle[], i: number) => {
    // re-assign vehicle seq # except exist #1
    let order = 2;
    vehicles.forEach((e, index) => {
        if(index === i ) {
            vehicles[index].vehicleSeqNbr = 1;
        }else {
            vehicles[index].vehicleSeqNbr = order;
            order++;
        }
    });

    return vehicles;
};

export const setSailingProps = (values: any) => {
    for (var i = 0; i <= 6; i++) {
        // week 1
        values.amTimes[i].permitRoutetimeId = values[`amTime${i+1}`]  !== undefined && values[`amTime${i+1}`] !== ''
            ? +values[`amTime${i+1}`] : 0;
        values.amTimes[i].terminalId = values[`amTime${i+1}`] !== undefined && values[`amTime${i+1}`] !== '' 
            ? +values.amTerminalId : 0;
        values.amTimes[i].isSelected = values[`amTime${i+1}`] !== undefined && values[`amTime${i+1}`] !== ''
            ? true : false;

        values.pmTimes[i].permitRoutetimeId = values[`pmTime${i+1}`] !== undefined && values[`pmTime${i+1}`] !== ''
            ? +values[`pmTime${i+1}`] : 0;
        values.pmTimes[i].terminalId = values[`pmTime${i+1}`] !== undefined && values[`pmTime${i+1}`] !== '' 
            ? +values.pmTerminalId : 0;
        values.pmTimes[i].isSelected = values[`pmTime${i+1}`] !== undefined && values[`pmTime${i+1}`] !== ''
            ? true : false;

        if(values.scheduleTypeInd === "2") {
            // week 2
            values.am2Times[i].permitRoutetimeId = values[`am2Time${i+1}`]  !== undefined && values[`am2Time${i+1}`] !== ''
            ? +values[`am2Time${i+1}`] : 0;
            
            values.am2Times[i].terminalId = values[`am2Time${i+1}`] !== undefined && values[`am2Time${i+1}`] !== ''
            ? +values.amTerminalId : 0;
            values.am2Times[i].isSelected = values[`am2Time${i+1}`] !== undefined && values[`am2Time${i+1}`] !== ''
            ? true : false;
    
            values.pm2Times[i].permitRoutetimeId = values[`pm2Time${i+1}`] !== undefined && values[`pm2Time${i+1}`] !== ''
            ? +values[`pm2Time${i+1}`] : 0;
            values.pm2Times[i].terminalId = values[`pm2Time${i+1}`] !== undefined && values[`pm2Time${i+1}`] !== ''
            ? +values.pmTerminalId : 0;
            values.pm2Times[i].isSelected = values[`pm2Time${i+1}`] !== undefined && values[`pm2Time${i+1}`] !== ''
            ? true : false;    
        }
    }

    return values;
};

export const isReady = (values: PermitFormValues) => { // step 2 validation
    const week1AmTimes = values.amTimes.filter((x: SailingValues) => x.isSelected);
    const week1PmTimes = values.pmTimes.filter((x: SailingValues) => x.isSelected);

    const week2AmTimes = values.am2Times.filter((x: SailingValues) => x.isSelected);
    const week2PmTimes = values.pm2Times.filter((x: SailingValues) => x.isSelected);
    
    let ready = !!(week1AmTimes.length >= 3 && week1PmTimes.length >= 3);

    if(values.scheduleTypeInd === '2') {
        ready = !!(week1AmTimes.length >= 3 
            && week1PmTimes.length >= 3
            && week2AmTimes.length >= 3
            && week2PmTimes.length >= 3) 
    }

    return ready;
}

export const getSailingTime = (arr: DropdownOption[], routeTimeId: number) => {
    if (arr !== undefined && arr.find(x => x.value === `${routeTimeId}`) !== undefined) {
        return arr.find(x => x.value === `${routeTimeId}`)!.text;
    }
}

export const getPermitColor = (predicate: string) => {
    switch (predicate) {
        case 'pending':
          return 'yellow';
        case 'expired':
          return 'orange';
        default:
            return 'green';
    }
}

export const setPermitProps = (permit: Permit) => {
    permit.isFinalView = true;
    permit.amTimes = [];
    permit.am2Times = [];
    permit.pmTimes = [];
    permit.pm2Times = [];

    for(var i: number = 0; i <= 6; i++) {
        // week 1
        permit.amTimes[i] = new SailingValues();
        permit.amTimes[i].dayId = i + 1;
        permit.amTimes[i].weekId = 1;
        permit.amTimes[i].permitRoutetimeId = 0;

        permit.pmTimes[i] = new SailingValues();
        permit.pmTimes[i].dayId = i + 1;
        permit.pmTimes[i].weekId = 1;
        permit.pmTimes[i].permitRoutetimeId = 0;

        // week 2
        permit.am2Times[i] = new SailingValues();
        permit.am2Times[i].dayId = i + 1;
        permit.am2Times[i].weekId = 2;
        permit.am2Times[i].permitRoutetimeId = 0;

        permit.pm2Times[i] = new SailingValues();
        permit.pm2Times[i].dayId = i + 1;
        permit.pm2Times[i].weekId = 2;
        permit.pm2Times[i].permitRoutetimeId = 0;
    }

    // set missing isPrimary prop
    permit.vehicles.forEach((vehicle) => {
        vehicle.vehicleIsPrimary = vehicle.vehicleSeqNbr === 1 ? true : false;
    });

    permit.sailingTimes.forEach((s) => {
        // also week 1 vs week 2
        // should use [][]
        // week 1
        if (s.weekId === 1) {
            if(s.terminalId === +permit.amTerminalId) {
                permit.amTimes[s.dayId - 1].weekId = s.weekId;
                permit.amTimes[s.dayId - 1].terminalId = s.terminalId;
                permit.amTimes[s.dayId - 1].permitRoutetimeId = s.permitRoutetimeId;
                permit.amTimes[s.dayId - 1].isSelected = true;
            }else {
                permit.pmTimes[s.dayId - 1].weekId = s.weekId;
                permit.pmTimes[s.dayId - 1].terminalId = s.terminalId;
                permit.pmTimes[s.dayId - 1].permitRoutetimeId = s.permitRoutetimeId;
                permit.pmTimes[s.dayId - 1].isSelected = true;
            }
        }else {
            if(s.terminalId === +permit.amTerminalId) {
                permit.am2Times[s.dayId - 1].weekId = s.weekId;
                permit.am2Times[s.dayId - 1].terminalId = s.terminalId;
                permit.am2Times[s.dayId - 1].permitRoutetimeId = s.permitRoutetimeId;
                permit.am2Times[s.dayId - 1].isSelected = true;
            }else {
                permit.pm2Times[s.dayId - 1].weekId = s.weekId;
                permit.pm2Times[s.dayId - 1].terminalId = s.terminalId;
                permit.pm2Times[s.dayId - 1].permitRoutetimeId = s.permitRoutetimeId;
                permit.pm2Times[s.dayId - 1].isSelected = true;
            }
        }
    });

    return permit;
}

export const getPermitType = (permitId: number, lowercase = false) => {
    switch (permitId) {
        case 2:
          return lowercase ? 'carpool' : 'Carpool';
        case 3:
          return lowercase ? 'vanpool' : 'Vanpool';
        default:
            return lowercase ? 'unsure' : 'Unsure';
    }
}

export const getButtonSize = () => {
    return isMobileOnly ? BUTTON_SIZE_MOBILE : BUTTON_SIZE;
}